export const MOBILE_BREAKPOINT = 875; // px (width)

export const DEFAULT_STREAM_URL =
  'https://4c62a87c1810.us-west-2.playback.live-video.net/api/video/v1/us-west-2.049054135175.channel.tNRdO5OP9FBx.m3u8';

export const NUMBER_OF_AI_PARTICIPANTS = 5;

export const TIME_BOUNDS = { MIN: 20000, MAX: 50000 }; // in seconds per lap

export const USER_KEY = 'user';
export const USER_STARTING_LAP_DURATION = 50000; // in seconds per lap
export const NEW_TIME_EVERY_LAP = true;

export const ACCELERATION_KEY = { key: 'w', keyCode: 87 };
